import React from 'react';
import FanViewer from '../../components/streaming/FanViewer';

export default function FanView() {
  return <FanViewer />;
}
